import auditLogs from 'src/features/audit-logs/shared/locales/pl';
import tenantAuditLogs from 'src/features/audit-logs/tenant/locales/pl';
import authFeature from 'src/features/auth/locales/pl';
import bookingRules from 'src/features/booking-rules/locales/pl';
import bookings from 'src/features/bookings/locales/pl';
import calendarIntegration from 'src/features/calendar-integration/locales/pl';
import issues from 'src/features/issues/locales/pl';
import statistics from 'src/features/statistics/locales/pl';
import employeesGroups from 'src/features/employees-groups/locales/pl';
import employees from 'src/features/employees/locales/pl';
import tenantManageInvitationDialogue from 'src/features/manage-invitation-to-site/locales/pl';
import password from 'src/features/password/locales/pl';
import spaceGroups from 'src/features/space-groups/locales/pl';
import spaces from 'src/features/spaces/locales/pl';
import stateMachine from 'src/state-machine/locales/pl';
import auth from './auth.json';
import common from './common.json';
import components from './components.json';
import organizationDetails from './organization-details.json';
import routes from './routes.json';
import validation from './validation.json';

const resources = {
  common,
  auth,
  validation,
  employees,
  routes,
  organizationDetails,
  tenantManageInvitationDialogue,
  password,
  components,
  auditLogs,
  tenantAuditLogs,
  authFeature,
  stateMachine,
  employeesGroups,
  spaces,
  bookingRules,
  spaceGroups,
  bookings,
  calendarIntegration,
  issues,
  statistics,
} as const;

export default resources;
